import { isAddress } from '@ethersproject/address';
import { parseFixed } from '@ethersproject/bignumber';
import { Contract } from '@ethersproject/contracts';
import { BigNumber } from 'ethers';
import { Resolution } from '@unstoppabledomains/resolution';
import { UnsLocation } from '@unstoppabledomains/resolution/build/types/publicTypes';
import { SupportedConnectors } from '../config/constants';

export const fetcher =
    (library: any, abi: any) =>
    (...args: any) => {
        const [arg1, arg2, ...params] = args;

        if (isAddress(arg1)) {
            const address = arg1;
            const method = arg2;

            const contract = new Contract(address, abi, library.getSigner());

            return contract[method](...params);
        }

        const method = arg1;

        return library[method](arg2, ...params);
    };

export const calculateMargin = (value: BigNumber) =>
    value.mul(BigNumber.from(10000).add(BigNumber.from(1000))).div(BigNumber.from(10000));

export const toBigNumber = (value: string, decimalPlaces: number = 18) => {
    if (!value.includes('.')) {
        return parseFixed(value, decimalPlaces);
    }

    const parts = value.split('.');
    const fraction = parts[1].slice(0, decimalPlaces);

    return parseFixed(`${parts[0]}.${fraction}`, decimalPlaces);
};

export const preventOverflow = (value: string, decimalPlaces: number = 18) => {
    if (!value.includes('.')) return value;

    const parts = value.split('.');

    if (decimalPlaces === 0 && !parts[1]) return parts[0];

    const fraction = parts[1].slice(0, decimalPlaces);

    return `${parts[0]}.${fraction}`;
};

export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

//function to get Unstoppable Domains domain if it exists
export const reverseUrl = async (address: string) => {
    const resolution = new Resolution();

    const resolvedDomain = await resolution.reverse(address, {
        location: UnsLocation.Layer2,
    });

    return resolvedDomain;
};

export const toHex = (num: number) => {
    const val = Number(num);
    return '0x' + val.toString(16);
};

export const getConnectorProvider = (activeConnector: SupportedConnectors | null) => {
    if (activeConnector === 'Bitkeep') {
        return window.bitkeep?.ethereum;
    }
    if (activeConnector === 'Nabox') {
        return window.NaboxWallet;
    }
    return (window as any).ethereum;
};
